import { useEffect, useState } from "react";

import { adminApi, clearAdminToken } from "../services/adminApi";

const SEEN_NOTIFICATION_KEY = "zayasSeenNotificationIds";

function getSeenNotificationIds() {
  return new Set(JSON.parse(localStorage.getItem(SEEN_NOTIFICATION_KEY) || "[]"));
}

function saveSeenNotificationIds(seenIds) {
  localStorage.setItem(
    SEEN_NOTIFICATION_KEY,
    JSON.stringify([...seenIds].slice(-100)),
  );
}

export default function useAdminNotifications(isAuthenticated) {
  const [toasts, setToasts] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!isAuthenticated) {
      setToasts([]);
      setUnreadCount(0);
      return undefined;
    }

    let isActive = true;

    const pollNotifications = async () => {
      try {
        const payload = await adminApi("/notifications/");

        if (!isActive) {
          return;
        }

        setUnreadCount(payload.unread_count || 0);

        const seenIds = getSeenNotificationIds();
        const freshNotifications = (payload.results || []).filter((notification) => {
          return !notification.is_read && !seenIds.has(notification.id);
        });

        if (freshNotifications.length) {
          setToasts((currentToasts) => {
            const newToasts = freshNotifications.map((notification) => ({
              id: notification.id,
              title: notification.title,
            }));

            return [...newToasts, ...currentToasts].slice(0, 3);
          });

          freshNotifications.forEach((notification) => {
            seenIds.add(notification.id);
          });
          saveSeenNotificationIds(seenIds);
        }
      } catch (requestError) {
        if (requestError.status === 401 || requestError.status === 403) {
          clearAdminToken();
        }
      }
    };

    pollNotifications();
    const intervalId = window.setInterval(pollNotifications, 30000);

    return () => {
      isActive = false;
      window.clearInterval(intervalId);
    };
  }, [isAuthenticated]);

  useEffect(() => {
    if (!toasts.length) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setToasts([]);
    }, 5000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [toasts]);

  return {
    toasts,
    unreadCount,
  };
}